import type { DocMigration } from "../docMigration";

enum FacadeStratumDocEntityPrefix {
  FacadeSpanStrata = "facadeSpanStrata",
  FacadeSweepStrata = "facadeSweepStrata",
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_282: DocMigration = {
  maxSchemaVersion: "0.0.282",
  description:
    "Rename doc.facadeSpanStratum (singular) to doc.facadeSpanStrata (plural) & rename doc.facadeSweepStratum (singular) to doc.facadeSweepStrata (plural).",
  apply(json: any): any {
    const facadeSpanStrata = {};
    const facadeSweepStrata = {};

    for (const id in json.facadeSpanStratum) {
      facadeSpanStrata[id] = json.facadeSpanStratum[id];
    }

    delete json.facadeSpanStratum;

    for (const id in json.facadeSweepStratum) {
      facadeSweepStrata[id] = json.facadeSweepStratum[id];
    }

    delete json.facadeSweepStratum;

    // Update any instances of facadeSpanStratum and facadeSweepStratum hashes in the doc

    for (const hash in json.locked) {
      const handle = json.locked[hash];
      remapFacadeStratumHash(json.locked, hash, handle);
    }

    for (const hash in json.hidden) {
      const handle = json.hidden[hash];
      remapFacadeStratumHash(json.hidden, hash, handle);
    }

    return {
      ...json,
      facadeSpanStrata,
      facadeSweepStrata,
    };
  },
};

export default migration_0_0_282;

function remapFacadeStratumHash(entitySet: any, hash: string, handle: any) {
  if (handle.type === "FACADE_SPAN_STRATUM") {
    delete entitySet[hash];
    const newHash = `${FacadeStratumDocEntityPrefix.FacadeSpanStrata}.${handle.id}`;
    entitySet[newHash] = handle;
  }

  if (handle.type === "FACADE_SWEEP_STRATUM") {
    delete entitySet[hash];
    const newHash = `${FacadeStratumDocEntityPrefix.FacadeSweepStrata}.${handle.id}`;
    entitySet[newHash] = handle;
  }
}
